module.exports = __webpack_public_path__ + "static/img/img_1.b49efc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_1.jpg
// module id = COEy
// module chunks = 1